import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Treatment } from 'libs/end-to-end/src/treatment';
import { RecommendedSolutionCard } from 'apps/sigma2-ui/src/components/ui/RecommendedSolutionCard';
import { Card } from 'apps/sigma2-ui/src/components/ui/Card';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

/**
 * Bottom section of the Deep Dive page that shows the top recommended solutions
 * @url https://www.figma.com/design/70fJfZJAnTZfJkslSuUdPS/Sigma-Squared-(Dev-Ready)?node-id=5022-13367&t=TQ6snDGYrS03N50I-0
 */
export const RecommendedSolutionsSection: React.FC<{
  topTreatments: Treatment[];
  onTreatmentClick: (treatmentIndex: number) => void;
}> = ({ topTreatments, onTreatmentClick }) => {
  const hasTopTreatments = topTreatments.length > 0;
  const language = useLanguage();

  if (!hasTopTreatments) {
    return (
      <Card paddingClassName="p-6 pb-8">
        <Spacing direction="vertical" size="lg">
          <S2Typography
            translatedContent={language.recommendedSolutionsSectionHeader()}
            variant={'headline-5-alt'}
          />

          <S2Typography
            translatedContent={language.recommendedSolutionsSectionEmptyDescription()}
            variant={'body-7'}
          />
        </Spacing>
      </Card>
    );
  }

  return (
    <Card paddingClassName="p-6 pb-8">
      <Spacing direction="vertical" size="lg">
        <S2Typography
          translatedContent={language.recommendedSolutionsSectionHeader()}
          variant={'headline-5-alt'}
        />

        <Spacing direction="horizontal" size="gap-3" className="items-stretch">
          {topTreatments.map((treatment, index) => {
            return (
              <div
                className="basis-1/3"
                key={`${treatment.type}-${treatment.metric}-${treatment.dimension}-${treatment.focusArea}-${treatment.level}`}
              >
                <RecommendedSolutionCard
                  treatmentType={treatment.type}
                  onClick={() => onTreatmentClick(index)}
                  impactFactor={treatment.impactFactor}
                />
              </div>
            );
          })}
        </Spacing>
      </Spacing>
    </Card>
  );
};
